<template>
  <div class="qr-instructions">
    <div class="qr-headline">
      <v-icon color="primary" class="mr-1">mdi-cellphone-information</v-icon>
      {{ headline }}
    </div>
    <ol class="qr-steps">
      <li v-for="(step, i) in steps" :key="i">{{ step }}</li>
    </ol>
    <div class="qr-note">* {{ note }}</div>
  </div>
</template>

<script>
import { QR_STEPS, QR_NOTE } from '@/qrPoster';
import { qrHeadline } from '@/meetingType';

export default {
  name: 'QrInstructions',
  props: {
    // ประเภทการประชุม: เปลี่ยนหัวข้อ (การประชุม / ลงทะเบียน)
    type: { type: String, default: '' },
  },
  data() {
    return { steps: QR_STEPS, note: QR_NOTE };
  },
  computed: {
    headline() {
      return qrHeadline(this.type);
    },
  },
};
</script>

<style scoped>
.qr-instructions {
  margin: 8px 0 16px;
  padding: 14px 16px;
  border-radius: 12px;
  background-color: #F5F7FA;
  text-align: left;
}

.qr-headline {
  color: #0C2F53;
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 6px;
}

.qr-steps {
  padding-left: 20px;
  color: #2B3A4D;
  font-size: 14px;
  line-height: 1.6;
}

.qr-note {
  margin-top: 6px;
  color: #5B6B7F;
  font-size: 13px;
}
</style>
